import dayjs from 'dayjs';

export function timeFormat(_format = 'MM-DD HH:mm:ss') {
  const newTime = new Date();
  newTime.setUTCSeconds(newTime.getUTCSeconds());
  return dayjs(newTime.toUTCString()).format(_format);
}